/**
 * Standalone trigger for the RecentlyAddedRegistryItemUpdateDrawer.
 *
 * Kept free of Catalog-barrel imports so non-Catalog modules (e.g. the
 * ShippingAddressAndCurrencyDialogsProvider) can open the drawer without
 * creating a circular import through the Catalog index.
 */
let globalOpenDrawerImmediately: (() => void) | null = null;

export const setOpenRecentlyAddedDrawer = (open: (() => void) | null) => {
  globalOpenDrawerImmediately = open;
};

export const triggerDrawerOpen = () => {
  globalOpenDrawerImmediately?.();
};
